import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiHideFor
} from '@elastic/eui'

import IntroCards from './IntroLINUXToC'
import IntroCardsMobile from './IntroLINUXToC_mobile'

export default function IntroHome() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="m">
            <h2>LINUX Software</h2>
        </EuiTitle>
        <EuiTitle size="s">
            <h4>IP Kamera Überwachung</h4>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
        <EuiFlexItem>
            <EuiHideFor sizes={['xs', 's', 'm', 'l']}>
              <IntroCards />
            </EuiHideFor>
            <EuiHideFor sizes={['xl']}>
              <IntroCardsMobile />
            </EuiHideFor>
        </EuiFlexItem>
    </EuiFlexGroup>
  </React.Fragment>
  );
}